/**
 * Analytics service for tracking events and page views
 */

// Determine environment based on hostname
export const determineEnvironment = () => {
    const hostname = window.location.hostname;
    // console.log("Analytics: Current hostname is", hostname);
    
    if (hostname.includes('test.southvanmed.com')) {
      console.log("Analytics: Environment detected as TEST");
      return 'test';
    }
    
    if (hostname === 'localhost' || hostname.includes('127.0.0.1')) {
      console.log("Analytics: Environment detected as DEVELOPMENT");
      return 'development';
    }
    
    console.log("Analytics: Environment detected as PRODUCTION");
    return 'production';
  };
  
  // Track page views
  export const trackPageView = (path, authenticated) => {
    window.dataLayer = window.dataLayer || [];
    
    const environment = determineEnvironment();
    const pageViewData = {
      'event': 'page_view',
      'environment': environment,
      'page_path': path,
      'user_authenticated': authenticated || false
    };
    
    // console.log("Analytics: Tracking page view", pageViewData);
    window.dataLayer.push(pageViewData);
    
    // Log the current dataLayer state after pushing
    // console.log("Analytics: Current dataLayer state:", [...window.dataLayer]);
  };
  
  // Track user events
  export const trackEvent = (eventName, properties = {}) => {
    window.dataLayer = window.dataLayer || [];
    
    const environment = determineEnvironment();
    const eventData = {
      'event': eventName,
      'environment': environment,
      ...properties
    };
    
    // console.log(`Analytics: Tracking event "${eventName}"`, eventData);
    window.dataLayer.push(eventData);
    
    // Log the current dataLayer state after pushing
    // console.log("Analytics: Current dataLayer state:", [...window.dataLayer]);
  };
  
  // Debug helper function to check if GTM is properly loaded
  export const debugGTM = () => {
    if (window.google_tag_manager && window.google_tag_manager['GTM-PCZKD5DL']) {
      // console.log("Analytics: GTM is properly loaded!");
      return true;
    } else {
      console.warn("Analytics: GTM is not loaded or container ID doesn't match!");
      return false;
    }
  };
  
  // Initialize analytics
  export const initAnalytics = () => {
    // console.log("Analytics: Initializing analytics service");
    
    // Check if we already have a dataLayer
    if (window.dataLayer && window.dataLayer.length) {
      // console.log("Analytics: DataLayer already exists with", window.dataLayer.length, "items");
    } else {
      // console.log("Analytics: Creating new dataLayer");
      window.dataLayer = [];
    }
    
    // Set environment in dataLayer
    const environment = determineEnvironment();
    window.dataLayer.push({
      'event': 'analytics_initialized',
      'environment': environment
    });
    
    // Check if GTM is loaded after a short delay
    setTimeout(debugGTM, 1000);
    
    return environment;
  };